<div *ngIf="address.street != 'N/A'">
  <button mat-stroked-button color="primary" (click)="openGoogleMapsLocation(); $event.stopPropagation()" class="btLocation">
    <mat-icon>location_on</mat-icon>
    <span>Ver endereço no mapa</span>
  </button>
</div>

<mat-card class="google-maps view">
  <div class="row">
    <div class="col-xs-12 col-sm-6 blue-text">
      <div class="row">
        <div class="col-md-4 col-lg-3">CEP:</div>
        <div class="col-md-8 col-lg-9">{{ address?.cep ? address.cep : (address[0]?.postalCode ?? 'N/A') }}</div>
      </div>
      <div class="row">
        <div class="col-md-4 col-lg-3">País:</div>
        <div class="col-md-8 col-lg-9">
          {{ address?.country ? address.country : (address[0]?.country ?? 'N/A') }}
        </div>
      </div>
      <div class="row">
        <div class="col-md-4 col-lg-3">Estado:</div>
        <div class="col-md-8 col-lg-9">
          {{ address?.state ? address.state : (address[0]?.state ?? 'N/A') }}
        </div>
      </div>
      <div class="row">
        <div class="col-md-4 col-lg-3">Cidade:</div>
        <div class="col-md-8 col-lg-9">
          {{ address?.city ? address.city : (address[0]?.city ?? 'N/A') }}
        </div>
      </div>
      <div class="row">
        <div class="col-md-4 col-lg-3">Numero:</div>
        <div class="col-md-8 col-lg-9">
          {{ address?.number ? address.number : (address[0]?.line[1] ?? 'N/A') }}
        </div>
      </div>
      <div class="row">
        <div class="col-md-12 col-lg-3">Complemento:</div>
        <div class="col-md-12 col-lg-9">{{ address?.complement ?? 'N/A' }}</div>
      </div>
    </div>

    <!-- <div class="col-xs-12 col-sm-6" *ngIf="latLong[0] != 0">
      <div class="mapa view">
        <app-libremap-view
          width="100%"
          height="100%"
          frameborder="0"
          scrolling="no"
          marginheight="0"
          marginwidth="0"
          [draggable]="true"
          [latLong]="this.latLong"
        >
        </app-libremap-view>
      </div>
    </div> -->
  </div>
</mat-card>
